import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import { Contribution } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/lib/breakdownWorkedTime'

import Item from '../components/Item'
import ItemsBox from '../components/ItemsBox'

interface Props {
  specialHoursContributions: Contribution[]
  specialHoursMinutes: number
}

const SpecialHours = ({ specialHoursContributions, specialHoursMinutes }: Props) => {
  return (
    <ItemsBox
      label={i18n.t('clock_in.sidepanel.worked_hours.special_hours.title')}
      minutes={specialHoursMinutes}
      description={i18n.t('clock_in.sidepanel.worked_hours.special_hours.description')}
      displayBreakdown={specialHoursMinutes !== 0}
    >
      {specialHoursContributions.map((contribution) => (
        <Item key={contribution.name} label={contribution.name} minutes={contribution.minutes} />
      ))}
    </ItemsBox>
  )
}

export default SpecialHours
